<div class="form-group {{ settings.class }}" *ngIf="settings">
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div
    [ngClass]="
      'd-flex input-group align-items-center' + ' ' + settings.customInputClass
    "
  >
    <timepicker
      id="input{{ settings.fieldName | titlecase }}"
      name="input{{ settings.fieldName | titlecase }}"
      [(ngModel)]="data"
      [showMeridian]="settings.showMeridian"
      [showSpinners]="false"
      [showSeconds]="settings.showSeconds"
      [disabled]="disabled"
      [required]="required"
      (ngModelChange)="onChange()"
      [ngModelOptions]="{ standalone: true }"
    ></timepicker>
    <div class="input-group-append">
      <button
        type="button"
        class="time-input-clear input-group-text"
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        (click)="onClearInput()"
        [disabled]="disabled"
      >
        <span class="clear-text" style="display: none">Clear</span>
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message" *ngIf="showError">
    {{ errors[0] }}
  </div>
</div>
